// @ts-nocheck 09d73a5f
import wPhotoPropertiesPlugin from './plugins/wPhotoPropertiesPlugin';
import vectorImagePropertiesPlugin from './plugins/vectorImagePropertiesPlugin';

export {
  wPhotoPropertiesPlugin as WPhotoProperties,
  vectorImagePropertiesPlugin as VectorImageProperties,
};
